//Boletas y pagos
export const BOLETAS_LINK = '/boletas';
export const PAGOS_LINK = '/pagos';

//Mi plan
export const INTERNET_LINK = '/internet';
export const MOVIL_LINK = '/movil';
export const PLAN_LINK = '/mi-plan';

//Mi mundo GO!
export const MUNDO_GO_LINK = '/mundo-go';

//Mis solicitudes
export const REALIZAR_SOLICITUD_LINK = '/realizar-solicitud';
export const SOLICITUDES_TECNICAS_LINK = '/solicitudes-tecnicas';
export const SOLICITUDES_COMERCIALES_LINK = '/solicitudes-comerciales';
export const REAGENDAR_VISITA_LINK = '/reagendar-visita';
export const REGISTRO_ACTIVIDAD_LINK = '/registro-actividad'
export const RECLAMOS_LINK = '/reclamos';

//Sugerencias
export const SUGERENCIAS_LINK = '/sugerencias';

//beneficios
export const BENEFICIOS_LINK = '/beneficios'

//Mi conexión
export const CONFIGURACION = '/configuracion'
export const DISPOSITIVOS = '/dispositivos';
export const ACTIVAR_LINEAS = '/activacion-lineas'

//SIM
export const CAMBIO_SIM_LINK = '/cambio-sim';